import { useMemo, useState, type ReactNode } from 'react'
import { TitlebarSlotContext, useTitlebarSlotRef } from './titlebarSlot'

/**
 * A scope in which one header stands in for the titlebar of the grid below
 * it (see `titlebarSlot`). Wrap the header and the grid's area in it: a
 * layout's page content, a card, a dialog.
 */
export default function TitlebarSlotProvider({ children }: { children: ReactNode }) {
  const [element, setElement] = useState<HTMLElement | null>(null)
  const value = useMemo(() => ({ element, setElement }), [element])
  return <TitlebarSlotContext.Provider value={value}>{children}</TitlebarSlotContext.Provider>
}

/**
 * The spot in a header's row for its grid's titlebar actions. It takes no
 * room of its own (`display: contents`), so a header without a grid is
 * unchanged; put it just before the header's own actions.
 */
export function TitlebarSlotTarget() {
  const ref = useTitlebarSlotRef()
  return <div ref={ref} data-titlebar-slot="" className="contents" />
}
